import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

/** Same normalization as profiles.health_area legacy matching elsewhere in the app. */
export function normalizeHealthAreaName(area: string) {
  return area
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z]/g, "");
}

/**
 * UUID of the active `health_areas` row for the patient portal (admin checkbox "Paciente").
 */
export async function getPatientPortalHealthAreaId(
  client: SupabaseClient<Database>,
): Promise<string | null> {
  const { data: allAreas, error } = await client
    .from("health_areas")
    .select("id, name")
    .eq("is_active", true);

  if (error || !allAreas?.length) return null;

  const target = normalizeHealthAreaName("Paciente");
  const matched = allAreas.find((ha) => normalizeHealthAreaName(ha.name) === target);
  return matched?.id ?? null;
}
